import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY, PERCENT, DEFAULT_DECIMALS} from 'util/constants';
import {getPercent, getPercentDifference} from 'util/utils';

import {CLOUD_BILLING_ENTITY_TYPE} from 'containers/cloud-billing/utils/constants';

module.exports = {
    // eslint-disable-next-line max-params
    createFetchParams: params => ({
        ...params.pagination,
        ...params.filters,
        ...params.entities,
        exclude:        params.requestType,
        ordering:       params.sort,
        selected_month: Math.floor(params.selectedMonth / TIMESTAMP_MULTIPLY),
        type:           params.entityType
    }),
    ...storeModuleFactory({
        name:               'cloudBillingEntities',
        endpoint:           endpoints.cloudBilling.entitiesEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: (item, params) => {
            let results;

            switch (params.type) {
            case CLOUD_BILLING_ENTITY_TYPE.PROJECT:
                results = item.results.map(project => {
                    const
                        entityDifference = getPercentDifference(
                            parseFloat(project.spending_previous_month ? project.spending_previous_month.toFixed(DEFAULT_DECIMALS) : 0),
                            parseFloat(project.spending_selected_month ? project.spending_selected_month.toFixed(DEFAULT_DECIMALS) : 0)
                        );

                    return {
                        id:                    project.id,
                        name:                  project.name,
                        spending:              project.spending_selected_month,
                        previousSpending:      project.spending_previous_month,
                        spendingSelectedMonth: project.spending_selected_month,
                        spendingPreviousMonth: project.spending_previous_month,
                        percent:               Math.round(getPercent(item.total_selected_month, project.spending_selected_month.toFixed(DEFAULT_DECIMALS)) * PERCENT) / PERCENT,
                        difference:            Math.round(entityDifference.difference * PERCENT) / PERCENT,
                        icon:                  entityDifference.icon,
                        color:                 entityDifference.color
                    };
                });
                break;
            case CLOUD_BILLING_ENTITY_TYPE.ACCOUNT:
                results = item.results.map(account => {
                    const
                        entityDifference = getPercentDifference(
                            parseFloat(account.spending_previous_month ? account.spending_previous_month.toFixed(DEFAULT_DECIMALS) : 0),
                            parseFloat(account.spending_selected_month ? account.spending_selected_month.toFixed(DEFAULT_DECIMALS) : 0)
                        );

                    return {
                        id:                    account.id,
                        alias:                 account.alias,
                        name:                  account.alias,
                        vendorAccountNumber:   account.vendor_account_number,
                        spending:              account.spending_selected_month,
                        previousSpending:      account.spending_previous_month,
                        spendingSelectedMonth: account.spending_selected_month,
                        spendingPreviousMonth: account.spending_previous_month,
                        vendorIcon:            account.vendor.code.toLowerCase(),
                        vendorName:            account.vendor.title,
                        percent:               Math.round(getPercent(item.total_selected_month, account.spending_selected_month.toFixed(DEFAULT_DECIMALS)) * PERCENT) / PERCENT,
                        difference:            Math.round(entityDifference.difference * PERCENT) / PERCENT,
                        icon:                  entityDifference.icon,
                        color:                 entityDifference.color
                    };
                });
                break;
            case CLOUD_BILLING_ENTITY_TYPE.VENDOR:
                results = item.results.map(vendor => {
                    const
                        entityDifference = getPercentDifference(
                            parseFloat(vendor.spending_previous_month ? vendor.spending_previous_month.toFixed(DEFAULT_DECIMALS) : 0),
                            parseFloat(vendor.spending_selected_month ? vendor.spending_selected_month.toFixed(DEFAULT_DECIMALS) : 0)
                        );

                    return {
                        id:                    vendor.code,
                        name:                  vendor.title,
                        spending:              vendor.spending_selected_month,
                        previousSpending:      vendor.spending_previous_month,
                        spendingSelectedMonth: vendor.spending_selected_month,
                        spendingPreviousMonth: vendor.spending_previous_month,
                        vendorIcon:            vendor.code.toLowerCase(),
                        percent:               Math.round(getPercent(item.total_selected_month, vendor.spending_selected_month.toFixed(DEFAULT_DECIMALS)) * PERCENT) / PERCENT,
                        difference:            Math.round(entityDifference.difference * PERCENT) / PERCENT,
                        icon:                  entityDifference.icon,
                        color:                 entityDifference.color
                    };
                });
                break;
            case CLOUD_BILLING_ENTITY_TYPE.SERVICE:
                results = item.results.map(service => {
                    const
                        entityDifference = getPercentDifference(
                            parseFloat(service.spending_previous_month ? service.spending_previous_month.toFixed(DEFAULT_DECIMALS) : 0),
                            parseFloat(service.spending_selected_month ? service.spending_selected_month.toFixed(DEFAULT_DECIMALS) : 0)
                        );

                    return {
                        id:                    service.id,
                        name:                  service.name,
                        spending:              service.spending_selected_month,
                        previousSpending:      service.spending_previous_month,
                        spendingSelectedMonth: service.spending_selected_month,
                        spendingPreviousMonth: service.spending_previous_month,
                        vendorIcon:            service.vendor.code.toLowerCase(),
                        vendorName:            service.vendor.title,
                        percent:               Math.round(getPercent(item.total_selected_month, service.spending_selected_month.toFixed(DEFAULT_DECIMALS)) * PERCENT) / PERCENT,
                        difference:            Math.round(entityDifference.difference * PERCENT) / PERCENT,
                        icon:                  entityDifference.icon,
                        color:                 entityDifference.color
                    };
                });
                break;
            case CLOUD_BILLING_ENTITY_TYPE.REGION:
                results = item.results.map(region => {
                    const
                        entityDifference = getPercentDifference(
                            parseFloat(region.spending_previous_month ? region.spending_previous_month.toFixed(DEFAULT_DECIMALS) : 0),
                            parseFloat(region.spending_selected_month ? region.spending_selected_month.toFixed(DEFAULT_DECIMALS) : 0)
                        );

                    return {
                        shortCode:             region.code,
                        id:                    region.id,
                        name:                  region.name,
                        spending:              region.spending_selected_month,
                        previousSpending:      region.spending_previous_month,
                        spendingSelectedMonth: region.spending_selected_month,
                        spendingPreviousMonth: region.spending_previous_month,
                        vendorIcon:            region.vendor.code.toLowerCase(),
                        vendorName:            region.vendor.title,
                        percent:               Math.round(getPercent(item.total_selected_month, region.spending_selected_month.toFixed(DEFAULT_DECIMALS)) * PERCENT) / PERCENT,
                        difference:            Math.round(entityDifference.difference * PERCENT) / PERCENT,
                        icon:                  entityDifference.icon,
                        color:                 entityDifference.color
                    };
                });
                break;
            default:
                results = [];
            }

            return {
                results,
                totalPreviousMonth: item.total_previous_month,
                totalSelectedMonth: item.total_selected_month
            };
        }
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingEntities.js